var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBed = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5488 3.43555H13.7826L15 10.7399H1L2.21739 3.43555H3.604",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 10.7383V13.4774C15 13.7196 14.9038 13.9518 14.7326 14.123C14.5613 14.2943 14.3291 14.3905 14.087 14.3905H1.91304C1.67089 14.3905 1.43865 14.2943 1.26742 14.123C1.0962 13.9518 1 13.7196 1 13.4774V10.7383",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.8125 5.86914H14.1897",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.11826 4.35401C7.11667 4.43367 7.0839 4.50953 7.02699 4.56529C6.97009 4.62106 6.89359 4.65229 6.81391 4.65227H3.78382C3.74006 4.65269 3.69673 4.64367 3.65677 4.62582C3.61681 4.60797 3.58118 4.58171 3.55229 4.54884C3.5234 4.51596 3.50194 4.47725 3.48938 4.43533C3.47681 4.39341 3.47344 4.34927 3.47948 4.30593L3.64869 3.08853C3.6589 3.0153 3.69541 2.94828 3.75142 2.9C3.80743 2.85172 3.8791 2.82548 3.95304 2.82619H6.83948C6.87996 2.82618 6.92004 2.83425 6.95737 2.84992C6.9947 2.8656 7.02852 2.88856 7.05686 2.91747C7.08521 2.94638 7.1075 2.98065 7.12243 3.01828C7.13736 3.05591 7.14463 3.09614 7.14382 3.13662L7.11826 4.35401Z",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.03405 4.35401C9.03564 4.43367 9.06841 4.50952 9.12531 4.56529C9.18222 4.62106 9.25872 4.65228 9.3384 4.65227H12.3679C12.4116 4.65269 12.455 4.64366 12.4949 4.62581C12.5349 4.60796 12.5705 4.58171 12.5994 4.54883C12.6283 4.51596 12.6498 4.47724 12.6623 4.43532C12.6749 4.3934 12.6783 4.34926 12.6722 4.30592L12.503 3.08853C12.4928 3.01539 12.4564 2.94846 12.4005 2.90019C12.3446 2.85193 12.2731 2.82562 12.1993 2.82618H9.31222C9.27174 2.82617 9.23166 2.83424 9.19433 2.84992C9.157 2.86559 9.12318 2.88855 9.09483 2.91746C9.06649 2.94637 9.0442 2.98065 9.02927 3.01828C9.01434 3.05591 9.00706 3.09614 9.00787 3.13662L9.03405 4.35401Z",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.21875 3.43478V1.91304C2.21875 1.67089 2.31495 1.43865 2.48617 1.26742C2.6574 1.0962 2.88964 1 3.13179 1H12.8709C13.1131 1 13.3453 1.0962 13.5165 1.26742C13.6878 1.43865 13.784 1.67089 13.784 1.91304V3.43478",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.82422 14.3906V14.9993",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1758 14.3906V14.9993",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.15234 3.50391H9.004",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBed);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bed.a1cae29bef2ad9ea947e44e7bdd2ccfc.svg";